import React from 'react';
import SMMasterResource from 'resources/SMMasterResource';
import SMAppHelper from 'components/helpers/SMAppHelper';
import SMTrackHelper from 'components/helpers/SMTrackHelper';
import SMUserResource from 'resources/SMUserResource';

class SMUserContactView extends React.Component {

  constructor(props) {
    super(props);
    
    this.state = {
      areas: [],
      industries: [],
      jobs: [],
      errors: {},
    };
  }

  componentDidMount() {
    const countryId = 1;
    SMMasterResource.getLargeAreas(countryId, (areas, error, xhr)=>{
      this.setState({
        areas: areas
      });
    });
    SMMasterResource.getIndustries((industries, error, xhr)=>{
      this.setState({
        industries: industries
      });
    });
    SMMasterResource.getJobs((jobs, error, xhr)=>{
      this.setState({
        jobs: jobs
      });
    });
  }
  
  componentDidUpdate(prevProps, prevState) {
    if (this.props.isOpen === true && prevProps.isOpen === false) {
      SMAppHelper.canBodyScroll(false);
      $(this.refs.modal).niftyModal({
        afterClose: (modal, e)=>{
          this.dismiss();
          e.preventDefault();
          SMAppHelper.canBodyScroll(true);
        }
      });
      SMTrackHelper.pageView(location.pathname + "/contact");
    }
  }
  
  dismiss(e) {
    if (e) {
      e.preventDefault();
    } else {
      if(this.props.delegate && typeof this.props.delegate.contactViewDidClose === 'function'){
        this.props.delegate.contactViewDidClose();
      }
    }
  }
  
  formDidSubmit(e) {
    e.preventDefault();
    this.dismiss();
    $(this.refs.submitButton).attr('disabled', true);
    const formData = new FormData(this.refs.form);
    SMUserResource.postContact(this.props.currentUser.id, formData, (contact, error, xhr)=>{
      $(this.refs.submitButton).attr('disabled', false);
      if (error) {
        switch (xhr.status) {
          case 400: 
            const errorsArray = xhr.responseJSON.errors;
            let errors = {};
            errorsArray.forEach((error)=>{
              errors[error.field] = error.message;
            });
            this.setState({errors: errors});
            break;
          case 500: 
            break;
        }
      } else {
        $(".md-close").click();
        if(this.props.delegate && typeof this.props.delegate.contactDidCreated === 'function'){
          this.props.delegate.contactDidCreated();
        }
      }
    });
  }
  
  areaDidChange(e) {
    this.requestParams.state = e.currentTarget.value;
  }
  
  renderLargeAreaOptions() {
    let rows = [
      <option key="none" value="">{I18n.t("service.label_000047")}</option>
    ];
    this.state.areas.forEach((area, i)=>{
      rows.push(
        <option key={i} value={area.name}>{area.name_text}</option>
      );
    });
    return rows;
  }
  
  renderIndustryOptions() {
    let rows = [
      <option key="none" value="">{I18n.t("service.label_000047")}</option>
    ];
    this.state.industries.forEach((industry, i)=>{
      rows.push(
        <option key={i} value={industry.name}>{industry.name_text}</option>
      );
    });
    return rows;
  }
  
  renderJobOptions() {
    let rows = [
      <option key="none" value="">{I18n.t("service.label_000047")}</option>
    ];
    this.state.jobs.forEach((job, i)=>{
      rows.push(
        <option key={i} value={job.name}>{job.name_text}</option>
      );
    });
    return rows;
  }
  
  renderFormItemError(name) {
    const message = this.state.errors[name];
    if (message) { 
      return(
        <p className="popup-form__required"><i className="fa fa-exclamation-circle"></i>{message}</p>
      );
    }
    return null;
  }
  
  render() {

    return(
      <div>
        <div className="md-modal md-effect-101" ref="modal">
    			<div className="md-content">
            <div className="page__popup">
              <form ref="form" onSubmit={this.formDidSubmit.bind(this)}>
                <div className="page__popup-col1">
                  <p className="page__popup__cancel search-change__cancel"><a onClick={this.dismiss.bind(this)} className="md-close" href="#"><span className="page__popup__cancel-icon search-change__cancel-icon">×</span><span>キャンセル</span></a></p>
                  <div className="popup-headline">
                    <h2 className="popup-headline__title">連絡先情報の入力</h2>
                    <p className="popup-headline__text">お問い合わせをするには、連絡先情報の入力が必要です。<br className="sm-hide" />下記の情報を入力して、最下部の「登録する」ボタンを押してください。</p>
                  </div>
                  <div className="row">
                    <div className="odd-col__line clearfix">
                      <div className="col-md-3">
                        <h2 className="popup-form__title">
                          <span className="icon-form icon-form__required">必須</span>
                          <span className="popup-form__title-text">姓名</span>
                        </h2>
                      </div>
                      <div className="col-md-9">
                        <div className="information-name">
                          <label>
                            <span className="popup-form__label">姓</span>
                            <input type="text" name="family_name" id="user_contact_family_name" className="form-text servicse-form-text" />
                          </label>
                          {this.renderFormItemError("family_name")}
                        </div>
                        <div className="information-name">
                          <label>
                            <span className="popup-form__label">名</span>
                            <input type="text" name="given_name" id="user_contact_given_name" className="form-text servicse-form-text" />
                          </label>
                          {this.renderFormItemError("given_name")}
                        </div>
                      </div>
                    </div>
                    <div className="odd-col__line clearfix">
                      <div className="col-md-3">
                        <h2 className="popup-form__title">
                          <span className="icon-form icon-form__optional">任意</span>
                          <span className="popup-form__title-text">法人・団体名</span>
                        </h2>
                      </div>
                      <div className="col-md-9">
                        <input placeholder="株式会社スペースマーケット" type="text" name="corp_name" id="user_contact_corp_name" className="form-text servicse-form-text w100pa" />
                        {this.renderFormItemError("corp_name")}
                      </div>
                    </div>
                    <div className="odd-col__line clearfix">
                      <div className="col-md-3">
                        <h2 className="popup-form__title">
                          <span className="icon-form icon-form__optional">任意</span>
                          <span className="popup-form__title-text">部署名・肩書</span>
                        </h2>
                      </div>
                      <div className="col-md-9">
                        <input placeholder="人事部人事課 課長" type="text" name="department" id="user_contact_department" className="form-text servicse-form-text w100pa" />
                        {this.renderFormItemError("department")}
                      </div>
                    </div>
                    <div className="odd-col__line clearfix">
                      <div className="col-md-3">
                        <h2 className="popup-form__title">
                          <span className="icon-form icon-form__required">必須</span>
                          <span className="popup-form__title-text">郵便番号</span>
                        </h2>
                      </div>
                      <div className="col-md-9">
                        <label>
                          <span className="popup-form__label">ハイフンなしの半角数字。入力すると住所が自動補完されます</span>
                          <input maxLength="10" placeholder="1600023" size="10" type="text" name="postal_code" id="user_contact_postal_code" className="form-text servicse-form-text w110" />
                        </label>
                        {this.renderFormItemError("postal_code")}
                      </div>
                    </div>
                    <div className="odd-col__line clearfix">
                      <div className="col-md-3">
                        <h2 className="popup-form__title">
                          <span className="icon-form icon-form__required">必須</span>
                          <span className="popup-form__title-text">都道府県・<br className="sm-hide" />市区町村</span>
                        </h2>
                      </div>
                      <div className="col-md-9">
                        <div className="information-state">
                          <label htmlFor="user_contact_state">
                            <span className="popup-form__label">都道府県</span>
                          </label>
                          <div className="request-select__area">
                            <span className="service-select">
                              <select name="state" id="user_contact_state" className="service-select__purpose">
                                {this.renderLargeAreaOptions()}
                              </select>
                            </span>
                          </div>
                          {this.renderFormItemError("state")}
                        </div>
                        <div className="information-city">
                          <label>
                            <span className="popup-form__label">市区町村</span>
                            <input placeholder="新宿区" type="text" name="city" id="user_contact_city" className="form-text servicse-form-text w100pa" />
                          </label>
                          {this.renderFormItemError("city")}
                        </div>
                      </div>
                    </div>
                    <div className="odd-col__line clearfix">
                      <div className="col-md-3">
                        <h2 className="popup-form__title">
                          <span className="icon-form icon-form__required">必須</span>
                          <span className="popup-form__title-text">町名・番地</span>
                        </h2>
                      </div>
                      <div className="col-md-9">
                        <input placeholder="西新宿6-15-1 " type="text" name="address_1" id="user_contact_address_1" className="form-text servicse-form-text w100pa" />
                        {this.renderFormItemError("address_1")}
                      </div>
                    </div>
                    <div className="odd-col__line clearfix">
                      <div className="col-md-3">
                        <h2 className="popup-form__title">
                          <span className="icon-form icon-form__optional">任意</span>
                          <span className="popup-form__title-text">ビル名・部屋番号</span>
                        </h2>
                      </div>
                      <div className="col-md-9">
                        <input placeholder="セントラルパークタワー ラ・トゥール新宿 608" type="text" name="address_2" id="user_contact_address_2" className="form-text servicse-form-text w100pa" />
                        {this.renderFormItemError("address_2")}
                      </div>
                    </div>
                    <div className="odd-col__line clearfix">
                      <div className="col-md-3">
                        <h2 className="popup-form__title">
                          <span className="icon-form icon-form__required">必須</span>
                          <span className="popup-form__title-text">電話番号</span>
                        </h2>
                      </div>
                      <div className="col-md-9">
                        <div className="information-name sm-information__w100pa">
                          <label>
                            <span className="popup-form__label">ハイフンなしの半角数字</span>
                            <input placeholder="0312345678" type="tel" name="tel" id="user_contact_tel" className="form-text servicse-form-text" />
                          </label>
                          {this.renderFormItemError("tel")}
                        </div>
                      </div>
                    </div>
                    <div className="odd-col__line clearfix">
                      <div className="col-md-3">
                        <h2 className="popup-form__title">
                          <span className="icon-form icon-form__optional">任意</span>
                          <span className="popup-form__title-text">業種・職種</span>
                        </h2>
                      </div>
                      <div className="col-md-9">
                        <div className="information-name sm-information__w100pa">
                          <label htmlFor="user_contact_industry_id">
                            <span className="popup-form__label">業種</span>
                          </label>
                          <div className="request-select__area">
                            <span className="service-select">
                              <select name="industry_id" id="user_contact_industry_id" className="service-select__purpose">
                                {this.renderIndustryOptions()}
                              </select>
                            </span>
                          </div>
                          {this.renderFormItemError("industry_id")}
                        </div>
                        <div className="information-name sm-information__w100pa">
                          <label htmlFor="user_contact_job_id">
                            <span className="popup-form__label">職種</span>
                          </label>
                          <div className="request-select__area">
                            <span className="service-select">
                              <select name="job_id" id="user_contact_job_id" className="service-select__purpose">
                                {this.renderJobOptions()}
                              </select>
                            </span>
                          </div>
                          {this.renderFormItemError("job_id")}
                        </div>
                      </div>
                    </div>
                    <div className="odd-col__line clearfix">
                      <div className="ta-c mt20 mb20 clearfix">
                        <div className="col-xs-12">
                          <input ref="submitButton" type="submit" name="commit" value="登録する" className="button-blue pt15 pb15 w200" />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </form>
            </div>  
          </div>
    		</div>
        <div className="md-overlay"></div>
    	</div>
    );
  }

}
export default SMUserContactView;



// WEBPACK FOOTER //
// ./app/javascript/components/users/SMUserContactView.jsx